<script>import { isUrlMethodPair } from "@inertiajs/core";
import { inertia } from "../index";
export let href = "";
export let as = "a";
export let data = {};
export let method = "get";
export let replace = false;
export let preserveScroll = false;
export let preserveState = null;
export let preserveUrl = false;
export let only = [];
export let except = [];
export let headers = {};
export let queryStringArrayFormat = "brackets";
export let async = false;
export let prefetch = false;
export let cacheFor = 0;
export let cacheTags = [];
export let viewTransition = false;
$: _method = isUrlMethodPair(href) ? href.method : method;
$: _href = isUrlMethodPair(href) ? href.url : href;
$: asProp = _method !== "get" ? "button" : as.toLowerCase();
$: elProps = {
  a: { href: _href },
  button: { type: "button" }
}[asProp] || {};
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
  this={asProp}
  use:inertia={{
    ...(asProp !== 'a' ? { href: _href } : {}),
    data,
    method: _method,
    replace,
    preserveScroll,
    preserveState: preserveState ?? _method !== 'get',
    preserveUrl,
    only,
    except,
    headers,
    queryStringArrayFormat,
    async,
    prefetch,
    cacheFor,
    cacheTags,
    viewTransition,
  }}
  {...$$restProps}
  {...elProps}
  on:focus
  on:blur
  on:click
  on:dblclick
  on:mousedown
  on:mousemove
  on:mouseout
  on:mouseover
  on:mouseup
  on:cancel-token
  on:before
  on:start
  on:progress
  on:finish
  on:cancel
  on:success
  on:error
  on:prefetching
  on:prefetched
>
  <slot />
</svelte:element>
